export default __webpack_public_path__ + "static/media/32_desktop.df613cc4.jpg";